module.exports = __webpack_public_path__ + "97fab8d857abb09525af2d6c3a3d9855.png";